import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toastAction } from '../../redux/action/toastAction';
import { makeQueryString } from '../../utils/MakeQueryString';
const DateFilter = () => {
  const [dateFilter, setDateFilter] = useState();
  const [searchParam] = useSearchParams();
  const navigate = useNavigate();
  const startDate = searchParam.get('startDate');
  const endDate = searchParam.get('endDate');
  const onChangeDate = (type, val) => {
    let date = { ...dateFilter };
    if (type === 'END_DATE') {
      date.endDate = val;
    } else {
      date.startDate = val;
    }
    setDateFilter(date);
  };
  const onSubmit = () => {
    if (!dateFilter.startDate || !dateFilter.endDate) {
      toastAction.error(
        'Please Select Start Date and End Date before apply filter'
      );
      return;
    }
    navigate({ search: makeQueryString(dateFilter) });
  };
  const onClearFilter = () => {
    setDateFilter({});
    navigate({ search: '' });
  };
  useEffect(() => {
    if (startDate && endDate) {
      setDateFilter({ startDate, endDate });
    }
  }, [searchParam]);
  return (
    <div className="flex justify-end my-8 w-[88%] mx-auto ">
      <div className="">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-4 ">
            <p className="caption">Start Date</p>
            <input
              className="rounded border-2 h-[55%]"
              type="date"
              value={dateFilter?.startDate || ''}
              onChange={({ target }) =>
                onChangeDate('START_DATE', target.value)
              }
            />
          </div>
          <div className="col-span-4 ">
            <p className="caption">End Date</p>
            <input
              className="rounded border-2 h-[55%]"
              type="date"
              value={dateFilter?.endDate || ''}
              onChange={({ target }) => onChangeDate('END_DATE', target.value)}
            />
          </div>
          <div className="col-span-2 flex  items-center">
            <button
              className="caption w-full bg-[#537FE7] py-2 px-4 rounded text-white h-[55%] mt-2"
              onClick={onSubmit}
            >
              Apply
            </button>
          </div>
          <div className="col-span-2 flex items-center">
            <button
              className="caption w-full py-2 px-4 rounded text-white bg-[#BDCDD6] h-[55%] mt-2"
              onClick={onClearFilter}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateFilter;
